import { ChannelConversation } from '@components/Messages'
import { AppLayout } from '@layouts/AppLayout'
import { useLocalSearchParams } from 'expo-router'
import { useTranslation } from 'react-i18next'

export default function ChannelDetails() {
  const { t } = useTranslation('Messages')
  const { channelId } = useLocalSearchParams<{ channelId: string }>()

  return (
    <AppLayout backRoute={{ label: t('backToList') }}>
      <ChannelConversation channelId={channelId as string} />
    </AppLayout>
  )
}
